<template>
    <div class="gcmcn-card-gradient manager-list">
        <user-form
            v-if="displayFormView"
            :users="managersList"
            :entity-uid="entity.uid"
            :role="role"
            @on-user-created="onUserCreated"
            @leave-form-view="displayFormView = false"
        ></user-form>
        <user-reset-password
            v-else-if="displayFormResetUserPassword"
            :user="selectedUser"
            :entity-uid="entity.uid"
            :is-entity-related="true"
            @on-user-updated="displayFormResetUserPassword = false"
            @leave-form-view="displayFormResetUserPassword = false"
        ></user-reset-password>
        <template v-else>
            <el-button
                type="primary"
                class="gcmcn-primary-btn small add-user-btn"
                icon="el-icon-plus"
                @click="onUserCreation">
            </el-button>
            <div class="user-count">
                {{ administratorCount }} {{ userLabel }}{{ administratorCount > 1 ? 's' : '' }}
            </div>
            <gcmcn-filters
                :filter-values="[selectedSortType, searchFilter]"
                @reset-filters="resetFilters"
                style="margin-top: 0;"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <template v-if="usersFiltered.length > 0">
                <div
                    v-for="user in userList"
                    :key="user.uid"
                    style="position: relative;"
                >
                    <user-card
                        ref="userCard"
                        :user="user"
                        :is-entity-related="true"
                        @editUserPassword="onUserChangePassword"
                        @deleteUser="deleteUser"
                    ></user-card>
                </div>
            </template>
            <template v-else-if="searchFilter">
                <p class="list-empty">No {{ userLabel }} matching this filter</p>
            </template>
        </template>
    </div>
</template>

<script>
import UserCard from '../Takers/relatedUser.vue';
import UserForm from './user-form.vue';
import UserResetPassword from '../Takers/user-change-password.vue';

import { GcmcnFilters, Dropdown, SearchFilter } from 'gcmcn-common';
import { mapGetters } from 'vuex';
export default {

    components: {
        UserCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        UserResetPassword,
        UserForm,
    },

    props: {
        entity: {
            type: Object,
            required: true,
        },
        role:{
            type: String,
            required: true,
        }
    },

    data (){
        return {
            selectedSortType: '',
            searchFilter: '',
            displayFormResetUserPassword: false,
            selectedUser: null,
            displayFormView: false,
        };
    },

    computed: {
        ...mapGetters([
            'userIsEntityAdmin'
        ]),
        userLabel(){
            if(this.role === 'MANAGER'){
                return 'manager';
            }
            return 'administrator';
        },
        usersNotInEntity (){
            return this.$store.getters.users.filter((u) => !u.entitys.includes(this.entity.uid));
        },
        managersRelatedToEntity (){
            return this.$store.getters.users.filter((u) => {
                return u.entitys.includes(this.entity.uid) && u.level === 'manager';
            });
        },
        availableManagers(){
            return [...this.usersNotInEntity, ...this.managers];
        },
        managersList(){
            if(this.role === 'MANAGER'){
                return this.usersNotInEntity;
            }
            return this.availableManagers;
        },
        usersFiltered (){
            let users = this.managersRelatedToEntity.slice();
            if(this.selectedSortType){
                users.sort((a, b) => a.verbose_name.localeCompare(b.verbose_name));
                if(this.selectedSortType === 'dsc'){
                    users.reverse();
                }
            }
            if(this.searchFilter){
                users = users.filter((u) => u.verbose_name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return users;
        },
        entityAdmins(){
            return this.usersFiltered.filter(
                user => this.userIsEntityAdmin(this.entity.uid, user)
            );
        },
        managers(){
            return this.usersFiltered.filter(
                user => !this.userIsEntityAdmin(this.entity.uid, user)
            );
        },
        userList(){
            if(this.role === 'MANAGER'){
                return this.managers;
            }
            return this.entityAdmins;
        },
        administratorCount(){
            if(this.role === 'MANAGER'){
                return this.managers.length;
            }
            return this.entityAdmins.length;
        }
    },

    mounted (){

    },

    methods: {
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        onUserCreation (){
            this.displayFormView = true;
        },
        async onUserCreated (){
            await this.triggerRefresh();
            this.displayFormView = false;
        },
        onUserChangePassword (user){
            this.$set(this, 'selectedUser', user);
            this.displayFormResetUserPassword = true;
        },
        async triggerRefresh(){
            await this.$store.dispatch('fetchModelByName', 'groups');
            await this.$store.dispatch('fetchModelByName', 'users');
        },
        deleteUser (uid){
            const user = JSON.parse(JSON.stringify(this.managersRelatedToEntity.find((u) => u.uid === uid)));
            let entitys = user.entitys.slice();
            entitys.splice(entitys.indexOf(this.entity.uid), 1);
            this.$store.dispatch('createItem', {
                item:{
                    action: 'DELETE',
                    email: user.email,
                    status: 'PENDING',
                },
                scopes: {'X-Entity-Uid': this.entity.uid},
                model: 'userManagementRequests',
                url: this.$store.state.api.meta.listModels.userManagementRequests.url,
            }).then(async (res) => {
                this.$store.dispatch('fundation/watchRequestStatus',{
                    url: res.url
                }).then(async () => {
                    this.$notify.success({
                        title: 'Success',
                        message: `User has been deleted`
                    });
                    await this.triggerRefresh();
                    this.$refs.userCard.resetLoading();
                }).catch(error => {
                    this.$message.error(error.data.verbose_status);
                    this.$refs.userCard.resetLoading();
                });
            }).catch((e) => {
                console.error(e);
                this.$message.error(`User couldn\'t be deleted`);
                this.$refs.userCard.resetLoading();
            });
        },
    },
};
</script>

<style lang="scss">
.add-user-btn{
    display: flex;
    margin-left: auto;
    i{
        margin-right: 0;
    }
}
.user-count{
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Entities/user-list.vue